export default {"src":"/planos/_next/static/media/whatsapp-image.0fcb6847.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};